import React, { memo, useRef, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import {setContextualHelp} from "actions/index.js";

window.mouseDownX = 0;
document.body.onmousedown = function() { 
  ++window.mouseDownX;
}
document.body.onmouseup = function() {
  --window.mouseDownX;
}

let counter=0;
const Documented = memo(({object, refObj, element, setContextualHelp, arg, children, className="", ...props}) => { 
    if (object && object.docElement) {
        element = object.docElement;
    }

    const onMouseOver = useCallback((e) => {
        //if (window.mouseDownX === 0) {
            setContextualHelp(element, arg);
        //}
    }, []);
    const onMouseLeave= useCallback(() => {
        //if (window.mouseDownX === 0) {
            setContextualHelp(undefined);
        //}
    }, []);

    className += " documented ";
    return (
        <div
          {... props}
          ref={refObj}
          className={className}
          onMouseLeave={onMouseLeave}
          onMouseOver={onMouseOver}
          >
          {children}
        </div>
    );
});

const mapDispatchToProps = (dispatch) => {
  return {
      setContextualHelp: (element, arg) => dispatch(setContextualHelp(element, arg)),
  };
};

export default connect(null, mapDispatchToProps)(Documented);
